import React from 'react';
import PropTypes from 'prop-types';
import FeatureGridCard from './FeatureGridCard';
import parse from 'html-react-parser';

const SectionFeaturesGrid = ({ header, headerClasses, subheader, subheaderClasses, items }) => {
  return (
    <div className="bg-[#F8F9FB] text-center lg:text-left px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-12 w-full">
      <p className={`${headerClasses || ''}`}>{parse(header)}</p>
      {subheader && <p className={`${subheaderClasses || ''}`}>{parse(subheader)}</p>}
      <div className="flex flex-col gap-11 justify-center items-center max-w-7xl mx-auto">
        <div className="flex flex-wrap gap-4 items-start">
          {items.map((item, index) => (
              <FeatureGridCard key={index} imageSrc={item.image.url} title={item.header} 
              headerClasses={item.headerClasses}
               description={item.body} />
          ))}
        </div>
      </div>
    </div>
  );
};

SectionFeaturesGrid.propTypes = {
  header: PropTypes.string,
  headerClasses: PropTypes.string,
  subheader: PropTypes.string,
  subheaderClasses: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string.isRequired
      }).isRequired,
      header: PropTypes.string,
      headerClasses: PropTypes.string,
      body: PropTypes.string,
    })
  ),
};

export default SectionFeaturesGrid;
